import React from "react";
import { Route, Routes } from "react-router-dom";

import { Layout } from "./layout";

import Home from "./home";
import Application from "./application";
import ChatLayout from "@/components/ChatLayout";
import Training from "./training";
// import Settings from "./settings";
import Profile from "./profile";

export default function Candidate() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="application/*" element={<Application />} />
        <Route path="training/*" element={<Training />} />
        <Route path="chat/*" element={<ChatLayout basePath="/candidate/chat" />} />
        {/* <Route path="experiences/*" element={<Experiences />} />
        <Route path="personal-info/*" element={<PersonalInfo />} />
        <Route path="preferences/*" element={<Preferences />} />
        <Route path="questionnaire/*" element={<Questionnaire />} />
        <Route path="resume/*" element={<Resume />} />
        <Route path="skills/*" element={<Skills />} /> */}
        <Route path="profile/*" element={<Profile />} />
        {/* <Route path="settings/*" element={<Settings />} /> */}
      </Route>
    </Routes>
  );
}
